import { useEffect, useState } from 'react';

import ClientGrid from 'components/ClientGrid';
import Page from 'components/Page';

import useClients from 'hooks/useClients';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const ClientsPage: FunctionComponent<Props> = ({ testId = TEST_ID }) => {
    const { clients = [], fetch } = useClients();

    const [hasMore, setHasMore] = useState(false);

    useEffect(() => {
        (async () => {
            const { done } = await fetch().next();

            setHasMore(!done);
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleNext = async () => await fetch().next();

    return (
        <Page className={styles.clientsPage} testId={testId}>
            <ClientGrid onNext={hasMore ? handleNext : undefined} rows={clients} />
        </Page>
    );
};

export default ClientsPage;
